import type { Game } from '@/constants/game.const';
import { getStrapiGameFromGame } from '@/utils/gameMappers';

export type ArticlesUrlOptions = {
  isFeatured?: boolean;
  pagination?: {
    pageNumber?: number;
    pageSize?: number;
  };
  game?: Game;
  slug?: string;
};

export const DEFAULT_ARTICLES_PER_PAGE = 10;

export function getArticlesPath(options: ArticlesUrlOptions): string {
  const { isFeatured, pagination = {}, game } = options;
  const { pageNumber, pageSize = DEFAULT_ARTICLES_PER_PAGE } = pagination;

  const queryParams = new URLSearchParams();
  queryParams.set('sort', 'CreatedOn:DESC');
  queryParams.set('populate', '*');

  if (pageNumber !== undefined) {
    queryParams.set('pagination[page]', pageNumber.toString());
    queryParams.set('pagination[pageSize]', pageSize.toString());
  }
  if (isFeatured !== undefined) {
    queryParams.set('filters[IsFeatured][$eq]', isFeatured.toString());
  }
  if (game !== undefined) {
    queryParams.set('filters[Game][$eq]', getStrapiGameFromGame(game));
  }
  if (options.slug !== undefined) {
    queryParams.set('filters[Slug][$eq]', options.slug);
  }

  return `/articles?${queryParams.toString()}`;
}
